import { styled } from '@mui/material/styles';
import { FullScreenBox } from '../full-screen-box';

export const Wrapper = styled(FullScreenBox)``;
